<table class="_table">
    <ng-container *ngFor="let row of rows; let first = first"
                  [ngSwitch]="client.isS || client.isM">

        <!-- Mobile -->
        <ng-container *ngSwitchCase="true">
            <tr>
                <th [class.p-t-3]="!first"
                    class="c1 col-11 no-wrap">{{row.title}}:</th>
            </tr>
            <tr>
                <ng-container *ngTemplateOutlet="valueTemplate"></ng-container>
            </tr>
        </ng-container>

        <!-- Desktop -->
        <ng-container *ngSwitchDefault>
            <tr>
                <th class="c1 col-11 no-wrap"
                    [class.p-t-3]="!first">{{row.title}}:</th>
                <ng-container *ngTemplateOutlet="valueTemplate"></ng-container>
            </tr>
        </ng-container>

        <ng-template #valueTemplate>
            <td class="c1 col-4 p-l-3-l p-l-3-x"
                [ngSwitch]="row.html">
                <div *ngSwitchCase="true"
                     [innerHtml]="row.value || (row.text || '' | translate)"></div>
                <ng-container *ngSwitchDefault>{{row.value || (row.text || '' | translate)}}</ng-container>
            </td>
        </ng-template>
    </ng-container>
</table>
